import React from 'react';
import PropTypes from 'prop-types';
import deleteIcon from 'core/assets/svg/delete-icon.svg';

import { ActionButton } from 'core/components/action-button';
import useSession from 'core/hooks/use-session';

import useStyles from './boats-form.styles';

const Boat = ({ index, item, onRemove }) => {
  const classes = useStyles();
  const { viewOnly } = useSession();

  return (
    <div className={classes.boatItem}>
      <div className={classes.boatContent}>
        <div>
          <h3 className={classes.boatTitle}>Boat {index + 1}</h3>
          <p className={classes.boatLength}>{item}ft hull length</p>
        </div>
        {!viewOnly && (
          <ActionButton
            onClick={() => onRemove(index)}
            className={classes.deleteButton}
            icon={deleteIcon}
            size="small"
          />
        )}
      </div>
    </div>
  );
};

Boat.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onRemove: PropTypes.func.isRequired
};

export default Boat;
